import Vue from 'vue';

import CoreButton from './CoreButton';
import CoreCard from './CoreCard';
import CoreContentArea from './CoreContentArea';
import CoreExpand from './CoreExpand';
import CoreIcon from './CoreIcon';
import CoreRecaptcha from './CoreRecaptcha ';
import CoreSpinner from './CoreSpinner';
import CoreInput from './CoreInput';
import CoreDynamicInput from './CoreDynamicInput';
import CoreAsyncButton from './CoreAsyncButton';
import CoreError from './CoreError';

const core = [
  CoreButton,
  CoreCard,
  CoreContentArea,
  CoreExpand,
  CoreIcon,
  CoreRecaptcha,
  CoreSpinner,
  CoreInput,
  CoreDynamicInput,
  CoreAsyncButton,
  CoreError,
];

core.forEach((component) => Vue.component(component.name, component));
